export default __webpack_public_path__ + "static/media/uploadDocument_ic.e716f38d.svg";